<template>
  <div class="container">
    <div class="container">
      <div class="row g-4">
        <div class="col-12 col-md-6 d-flex" v-for="item in data" :key="item.id">
          <contactTemplate :data="item" class="w-100" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import contactTemplate from '../share/ContactTemplate.vue'

export default {
  components: { contactTemplate },

  data() {
    return {
      data: []
    }
  },

  mounted() {
    this.data = this.getAllData(); // injoron subdomain-in
  },

  methods: {
    getAllData() {
      const allData = {
        pthprishtine: [
          {
            id: 10,
            icon: "fa-phone-volume",
            title: this.$te("menus.pthprishtine.care.cardleft.title")+" Prishtinë" ? this.$t("menus.pthprishtine.care.cardleft.title")+" Prishtinë" : null,
            tel1: this.$te("menus.pthprishtine.care.cardleft.tel1") ? this.$t("menus.pthprishtine.care.cardleft.tel1") : null
          }
        ],
        pthprizren: [
          {
            id: 11,
            icon: "fa-phone-volume",
            title: this.$te("menus.pthprizren.care.cardleft.title")+" Prizren" ? this.$t("menus.pthprizren.care.cardleft.title")+" Prizren" : null,
            tel1: this.$te("menus.pthprizren.care.cardleft.tel1") ? this.$t("menus.pthprizren.care.cardleft.tel1") : null
          }
        ],
        pthferizaj: [
          {
            id: 12,
            icon: "fa-phone-volume",
            title: this.$te("menus.pthferizaj.care.cardleft.title")+" Ferizaj" ? this.$t("menus.pthferizaj.care.cardleft.title") + " Ferizaj" : null,
            tel1: this.$te("menus.pthferizaj.care.cardleft.tel1") ? this.$t("menus.pthferizaj.care.cardleft.tel1") : null
          }
        ],
        pthpeje: [
          {
            id: 13,
            icon: "fa-phone-volume",
            title: this.$te("menus.pthpeje.care.cardleft.title") + " Peje" ? this.$t("menus.pthpeje.care.cardleft.title") + " Peje" : null,
            tel1: this.$te("menus.pthpeje.care.cardleft.tel1") ? this.$t("menus.pthpeje.care.cardleft.tel1") : null
          }
        ],
        pthmitrovice: [
          {
            id: 14,
            icon: "fa-phone-volume",
            title: this.$te("menus.pthmitrovice.care.cardleft.title") + " Mitrovice" ? this.$t("menus.pthmitrovice.care.cardleft.title") + " Mitrovice": null,
            tel1: this.$te("menus.pthmitrovice.care.cardleft.tel1") ? this.$t("menus.pthmitrovice.care.cardleft.tel1") : null
          }
        ],
        pthgjilan: [
          {
            id: 15,
            icon: "fa-phone-volume",
            title: this.$te("menus.pthgjilan.care.cardleft.title") + " Gjilan" ? this.$t("menus.pthgjilan.care.cardleft.title") + " Gjilan" : null,
            tel1: this.$te("menus.pthgjilan.care.cardleft.tel1") ? this.$t("menus.pthgjilan.care.cardleft.tel1") : null
          }
        ],
        pthgjakove: [
          {
            id: 16,
            icon: "fa-phone-volume",
            title: this.$te("menus.pthgjakove.care.cardleft.title") + " Gjakove" ? this.$t("menus.pthgjakove.care.cardleft.title") + " Gjakove": null,
            tel1: this.$te("menus.pthgjakove.care.cardleft.tel1") ? this.$t("menus.pthgjakove.care.cardleft.tel1") : null
          }
        ],
        ps: [
          {
            id: 17,
            icon: "fa-phone-volume",
            title: this.$te("menus.ps.care.cardleft.title") ? this.$t("menus.ps.care.cardleft.title") : null,
            fullName: this.$te("menus.ps.care.cardleft.fullName") ? this.$t("menus.ps.care.cardleft.fullName") : null,
            position: this.$te("menus.ps.care.cardleft.position") ? this.$t("menus.ps.care.cardleft.position") : null,
            email: this.$te("menus.ps.care.cardleft.email") ? this.$t("menus.ps.care.cardleft.email") : null,
            tel1: this.$te("menus.ps.care.cardleft.tel1") ? this.$t("menus.ps.care.cardleft.tel1") : null,
            address: this.$te("menus.ps.care.cardleft.address") ? this.$t("menus.ps.care.cardleft.address") : null,
            button1: this.$te("menus.ps.carecardleft.button1") ? this.$t("menus.ps.carecardleft.button1") : null,
            button2: this.$te("menus.ps.care.cardleft.button2") ? this.$t("menus.ps.care.cardleft.button2") : null
          }
        ]
      };

      // Bashkon të gjitha array-t në një
      return Object.values(allData).flat();
    }
  }
}
</script>

<style scoped>
.container {
  padding-top: 48px;
  padding-bottom: 48px;
  margin-bottom: 0 !important;
}
</style>
